import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { action } from 'satcheljs';

/**
 * Action to remove a given table view and items from mail and list-view stores
 */
export const removeTableView = action('removeTableView', (oldTableView: TableView) => ({
    oldTableView,
}));
